/* eslint-disable import/no-unresolved */
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from '@/styles/theme';
import { ProvidersProps } from '../providers.types';

const ThemesProvider: React.FC<ProvidersProps> = ({ children }) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    {children}
  </ThemeProvider>
);

export default ThemesProvider;
